module.exports = __webpack_public_path__ + "img/symbol_7.91ddea51.png";